import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllProducts(pagina2) {
    

  //console.log(valor);
    const productos =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Cultivo_en_proceso/"+pagina2+"/Productos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productos.push(doc.data());
    });
    return productos;
    

}
